import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { SettingDTO } from '../../../api/setting-api';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { FormikCellToggle, FormikDateInput, FormikNumberInput, FormikTextField } from '../../../components/formik';
import { yup } from '../../../components/basic/yup';
import SvgSave from '../../../assets/icons/Save';
import SvgDelete from '../../../assets/icons/Delete';
import SvgClose from '../../../assets/icons/Close';

interface SaveSettingModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedSetting?: SettingDTO;
    onHide: () => void;
    onSave: (values: SettingDTO) => void;
    onDelete?: (setting: SettingDTO) => void;
}

export function SaveSettingModal({
    show,
    allowEdit,
    selectedSetting,
    onHide,
    onSave,
    onDelete
}: SaveSettingModalProps) {
    const SettingSchema = yup.object().shape({
        id: yup.string().required(' '),
        value: yup.string().required(' '),
    });

    const defaultValues: SettingDTO = {
        
        id: selectedSetting ? selectedSetting.id :''
        ,
        
        
        value: selectedSetting ? selectedSetting.value :''
        ,
        
        
        
        
        
    };

    if (!show) return <></>;

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={ SettingSchema}
            onSubmit={onSave}
        >
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedSetting ? 'edit-setting' : 'new-setting'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedSetting && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedSetting)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    disabled={!allowEdit}
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }>
                    <Form>
                        <bd.Flex align="center" wrap>
                                <FormikTextField
                                    label="id"
                                    name="id"
                                    readOnly={!allowEdit || !!selectedSetting}
                                    width="11rem"
                                    handleEnter
                                />

                                <FormikTextField
                                    label="value"
                                    name="value"
                                    readOnly={!allowEdit}
                                    width="11rem"
                                    handleEnter
                                />

                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
